import styled from 'styled-components';
import { Helmet } from 'react-helmet';
import { FC, useEffect, useState } from 'react';
import { TiArrowBack } from 'react-icons/ti';
import { useHistory, useLocation } from 'react-router-dom';
import QueryString from 'qs';
import { RiLogoutCircleRLine } from 'react-icons/ri';
import ConfirmModal from '../modals/ConfirmModal';
import { useDispatch } from 'react-redux';
import { doLogout } from '../../store/auth.slice';
import { useTranslation } from 'react-i18next';

const Block = styled.div`
  .header {
    display: flex;
    justify-content: space-between;
    margin: 30px 0;
  }

  .side {
    width: 50px;
    padding-right: 25px;
    padding-top: 3px;

    .icon-back {
      margin-left: 15px;
    }

    .icon-size * {
      font-size: 24px;
    }

    & img {
      width: 22px;
    }
  }

  .title {
    color: #bb0665;
    font-size: 20px;
    font-weight: 700;
    text-align: center;
  }

  .font-tooltip {
    position: absolute;
    top: 25px;
    right: 5px;
    z-index: 1;

    .tooltip-box {
      width: 280px;
      height: 50px;
      box-shadow: 0 4px 8px 0 rgb(0 0 0 / 16%);
      border: 1.5px solid #d6d6d6;
      border-radius: 13px;
      background: white;
      position: relative;
      top: 8.5px;
      padding-top: 5px;

      .select {
        border-radius: 50%;
        border: 1px solid #d6d6d6;
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
      }

      .select-1 {
        font-size: 8px !important;
      }

      .select-2 {
        font-size: 10px !important;
      }

      .select-3 {
        font-size: 12px !important;
      }

      .select-4 {
        font-size: 14px !important;
      }

      .select-5 {
        font-size: 16px !important;
      }

      .selected {
        background: #bb0665;
        color: white;
      }

      .text {
        width: 50px;
        text-align: center;
        font-size: 12px !important;
      }
    }

    .img-box {
      & > img {
        width: 15px;
        margin-right: 15px;
      }

      position: relative;
      top: -56px;
      left: 210px;
    }
  }
`;

interface IProps {
  fontOption: number;
  setFontOption: (fontOption: number) => void;
}

const ShuttleHeader: FC<IProps> = ({ fontOption, setFontOption }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const date = String(query.date);
  const dispatch = useDispatch();

  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const [pathname, setPathname] = useState('');
  const [confirmLogoutVisible, setConfirmLogoutVisible] = useState(false);

  useEffect(() => {
    setPathname(history.location.pathname);
  }, [history]);

  const onSetFontOption = (fontOption: number) => {
    localStorage.setItem('fontOption', String(fontOption));
    setFontOption(fontOption);
    setIsTooltipOpen(false);
  };

  const onLogout = async () => {
    setConfirmLogoutVisible(false);
    dispatch(doLogout());
    window.location.reload();
  };

  return (
    <Block>
      <Helmet>
        <title>{t('shuttle.text.1')}</title>
      </Helmet>
      <div className="header">
        <div className="side">
          {pathname === '/' ? null : (
            <span className="icon-back icon-size">
              <TiArrowBack onClick={() => history.push(`/?date=${date}`)} />
            </span>
          )}
        </div>
        <div className="title">{t('shuttle.text.1')}</div>
        <div className="side text-right flex flex-justify-center w-100p">
          <span
            className="mr-4"
            onClick={() => setIsTooltipOpen((current) => !current)}
          >
            <img src="/images/button-font.png" alt="font button" />
          </span>
          <span className="icon-size mr-4">
            <RiLogoutCircleRLine
              onClick={() => setConfirmLogoutVisible(true)}
            />
          </span>
        </div>
      </div>

      {isTooltipOpen ? (
        <div className="font-tooltip">
          <div className="tooltip-box">
            <div className="flex flex-justify-around">
              {[...Array(5)].map((n, index) => {
                return (
                  <div
                    className={
                      `select select-${index + 1}` +
                      (fontOption === index + 1 ? ' selected' : '')
                    }
                    onClick={() => onSetFontOption(index + 1)}
                  >
                    {t('shuttle.text.2')}
                  </div>
                );
              })}
            </div>
            <div className="flex flex-justify-around">
              <div className="text" onClick={() => onSetFontOption(1)}>
                {t('shuttle.text.3')}
              </div>
              <div className="text" onClick={() => onSetFontOption(2)}>
                {t('shuttle.text.4')}
              </div>
              <div className="text" onClick={() => onSetFontOption(3)}>
                {t('shuttle.text.5')}
              </div>
              <div className="text" onClick={() => onSetFontOption(4)}>
                {t('shuttle.text.6')}
              </div>
              <div className="text" onClick={() => onSetFontOption(5)}>
                {t('shuttle.text.7')}
              </div>
            </div>
          </div>
          <div className="img-box">
            <img src="/images/tooltip-mark.png" alt="tooltip mark" />
          </div>
        </div>
      ) : null}

      {confirmLogoutVisible && (
        <ConfirmModal
          visible={confirmLogoutVisible}
          setVisible={setConfirmLogoutVisible}
          onConfirm={onLogout}
          titleText={t('common.layout.9')}
          messageText={t('common.layout.10')}
          confirmText={t('common.button.confirm')}
          cancelText={t('common.button.cancel')}
          className="text-center"
        />
      )}
    </Block>
  );
};

export default ShuttleHeader;
